export default [
	{ label: 'Mr.', value: 'MR' },
	{ label: 'Mrs.', value: 'MRS' },
	// { label: "Miss.", value: "MISS" },
	{ label: 'Ms.', value: 'MS' },
	// { label: "Master.", value: "MASTER" },
	// { label: "Mx.", value: "MX" },
	{ label: 'Dr.', value: 'DR' },
];
